import { render, staticRenderFns } from "./ZHTW.vue?vue&type=template&id=0d346ef8&scoped=true&"
import script from "./ZHTW.vue?vue&type=script&lang=js&"
export * from "./ZHTW.vue?vue&type=script&lang=js&"
import style0 from "./ZHTW.vue?vue&type=style&index=0&id=0d346ef8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d346ef8",
  null
  
)

export default component.exports